import { replica } from '@/shared/sync/replica';
import { type StoredSession, storedSessionSchema } from '../schemas/stored-session';

const KEY = 'kit.session';

/** The signed-in profile, persisted so the app opens signed in (and usable) without a connection. */
class SessionStore {
  private cached: StoredSession | null | undefined;
  private readonly listeners = new Set<() => void>();

  read = (): StoredSession | null => {
    if (this.cached !== undefined) return this.cached;
    const parsed = storedSessionSchema.safeParse(JSON.parse(localStorage.getItem(KEY) ?? 'null'));
    this.cached = parsed.success ? parsed.data : null;
    if (this.cached) replica.setActor(this.cached.user.id);
    return this.cached;
  };

  write(session: StoredSession | null): void {
    this.cached = session;
    if (session) {
      localStorage.setItem(KEY, JSON.stringify(session));
      replica.setActor(session.user.id);
    } else {
      localStorage.removeItem(KEY);
    }
    for (const listener of this.listeners) listener();
  }

  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };
}

export const sessionStore = new SessionStore();
